export const Logo = ({ dark = false, className = "h-9 sm:h-10" }) => (
  <img
    src={dark ? "/logo-dark.png" : "/logo-light.png"}
    alt="Storkjøkkensenteret Trøndelag"
    data-testid="site-logo"
    className={`w-auto select-none ${className}`}
    draggable={false}
  />
);
